/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import type SessionService from '@linc-technologies/linced-common/services/session';
import moment from 'moment';
import ReturnMonth from 'linced-app/enums/nz-moe-roll-return-month';

// Proto: nz_moe_roll_returns.ReturnDate.
export default class ReturnDate extends Model {
  declare [Type]: 'nz-roll-returns/return-date';

  @service
  declare session: SessionService;

  now() {
    return moment();
  }

  @attr('string')
  declare date: string | undefined;

  @attr('string', { defaultValue: '' })
  declare code: string;

  @computed('code')
  get month() {
    const label = ReturnMonth.getLabel(this.code);
    if (isEmpty(label)) {
      return '';
    }
    return label;
  }

  @attr('string')
  declare draftsOpen: string | undefined;

  @attr('string')
  declare draftsClose: string | undefined;

  @attr('string')
  declare officialOpen: string | undefined;

  @attr('string')
  declare officialClose: string | undefined;

  @computed('date')
  get year() {
    return moment(this.date, 'YYYY-MM-DD').year();
  }

  @computed(
    'session.school.id',
    'draftsOpen',
    'draftsClose',
    'officialOpen',
    'officialClose',
  )
  get status() {
    // For our Roll Return Test School (DEV+STAGING) make all returns official
    if (
      this.get('session.school.id') === '5250917d-7b78-4295-8306-72097571f43d'
    ) {
      return 'official';
    }
    const draftsOpen = moment(this.draftsOpen, 'YYYY-MM-DD');
    const draftsClose = moment(this.draftsClose, 'YYYY-MM-DD');
    const officialOpen = moment(this.officialOpen, 'YYYY-MM-DD');
    const officialClose = moment(this.officialClose, 'YYYY-MM-DD');
    if (
      this.now().isSameOrAfter(officialOpen, 'day') &&
      this.now().isSameOrBefore(officialClose, 'day')
    ) {
      return 'official';
    }
    if (
      this.now().isSameOrAfter(draftsOpen, 'day') &&
      this.now().isSameOrBefore(draftsClose, 'day')
    ) {
      return 'draft';
    }
    return 'closed';
  }
}
